// Ruby の String#[0, 160] と同じく、文字（Unicode code point）で数える。
const META_DESCRIPTION_CHARACTERS = 160;

export function salonpageMetaDescription(description: string) {
  return Array.from(description).slice(0, META_DESCRIPTION_CHARACTERS).join("");
}
